if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        // #region agent log
        fetch('http://127.0.0.1:7243/ingest/19983c63-725a-432e-8315-9e68f262acca',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({sessionId:'debug-session',runId:'pre-fix',hypothesisId:'D',location:'media-gallery.js:constructor',message:'media-gallery init',data:{hasViewer:!!this.elements.viewer,hasThumbnails:!!this.elements.thumbnails,thumbnailButtons:this.elements.thumbnails?.querySelectorAll?.('[data-target]')?.length||0,desktopLayout:this.dataset.desktopLayout||'',mobileLayout:this.dataset.mobileLayout||'',mqlMatch:this.mql.matches},timestamp:Date.now()})}).catch(()=>{});
        // #endregion agent log
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        // #region agent log
        fetch('http://127.0.0.1:7243/ingest/19983c63-725a-432e-8315-9e68f262acca',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({sessionId:'debug-session',runId:'pre-fix',hypothesisId:'E',location:'media-gallery.js:setActiveMedia',message:'set active media',data:{mediaId,prepend,hasActiveMedia:!!activeMedia,viewerHasSlider:!!this.elements.viewer?.slider,viewerScrollLeft:this.elements.viewer?.scrollLeft||0},timestamp:Date.now()})}).catch(()=>{});
        // #endregion agent log
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        // Prevent header reveal but keep current scroll position (no auto-scroll)
        this.preventStickyHeader();
        const enableThumbScrollFix = true;
        // #region agent log
        fetch('http://127.0.0.1:7243/ingest/19983c63-725a-432e-8315-9e68f262acca',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({sessionId:'debug-session',runId:'pre-fix',hypothesisId:'G',location:'media-gallery.js:setActiveMedia',message:'thumb scroll fix check',data:{enableThumbScrollFix,activeOffset:activeMedia?.offsetLeft||0,viewerHasSlider:!!this.elements.viewer?.slider,sliderScrollLeft:this.elements.viewer?.slider?.scrollLeft||0},timestamp:Date.now()})}).catch(()=>{});
        // #endregion agent log
        if (this.elements.viewer?.slider) {
          this.elements.viewer.slider.scrollTo({ left: activeMedia.offsetLeft });
          // #region agent log
          fetch('http://127.0.0.1:7243/ingest/19983c63-725a-432e-8315-9e68f262acca',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({sessionId:'debug-session',runId:'pre-fix',hypothesisId:'G',location:'media-gallery.js:setActiveMedia',message:'thumb scroll fix applied',data:{targetLeft:activeMedia.offsetLeft,afterScrollLeft:this.elements.viewer?.slider?.scrollLeft||0},timestamp:Date.now()})}).catch(()=>{});
          // #endregion agent log
        }
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        // #region agent log
        fetch('http://127.0.0.1:7243/ingest/19983c63-725a-432e-8315-9e68f262acca',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({sessionId:'debug-session',runId:'pre-fix',hypothesisId:'F',location:'media-gallery.js:setActiveThumbnail',message:'thumbnail active',data:{thumbnailTarget:thumbnail.dataset?.target||'',thumbScrollLeft:this.elements.thumbnails?.slider?.scrollLeft||0,isVisible:this.elements.thumbnails?.isSlideVisible?.(thumbnail,10)},timestamp:Date.now()})}).catch(()=>{});
        // #endregion agent log
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
